import { render, staticRenderFns } from "./requestDoctorAssociation.vue?vue&type=template&id=59cc7440&"
import script from "./requestDoctorAssociation.vue?vue&type=script&lang=js&"
export * from "./requestDoctorAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports